import React, { useEffect, useState } from 'react';
import LangStorageManager from '../lang/LangStorageManager';
import LanguageManager from '../lang/LanguageManager';
import './project.css';

export default function Project({ projects }) {
    const storage = new LangStorageManager(null);
    const[language, setLanguage] = useState(storage.getStorage());
    const[texts, setTexts] = useState(null);

    useEffect(() => {
        const loadText = async () => {
            const translator = new LanguageManager(storage.getStorage());
            await translator.loadTranslation();
            setTexts(translator.getAll());
        };
        loadText();
    }, [language]);

    return (
        <section id="projects">
            <h2>{texts?.projects?.title || "My Projects"}</h2>

            <div className="project-cards-container">
                {Object.entries(projects).map(([projectName, projectDetails]) => (
                    <div key={projectName} className="project-card">
                        <h2>{projectName}</h2>
                        <a href={projectDetails.link} target="_blank" rel="noopener noreferrer">
                            <img src={projectDetails.image} alt={projectName} title={projectName} />
                        </a>
                        <div className="technologies">
                            <h3>{texts?.projects?.technology || 'Technologies used'}</h3>
                            <div className="tech-icons">
                                {projectDetails.technologies.map((tech, index) => (
                                    <img key={index} src={`/img/skill/${tech}.png`} alt={tech} title={tech} className="tech-icon" />
                                ))}
                            </div>
                        </div>
                        <div className="view-project">
                            <a href={projectDetails.view} target='_blank' rel='noopener noreferrer'>
                                <img src={projectDetails.imageView} alt={projectName} title={projectName} />
                            </a>
                            <a href={projectDetails.link} target='_blank' rel='noopener noreferrer'>
                                <img src={projectDetails.imageLink} alt={projectName} title={projectName} />
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}